
const CONFIG = {
    ENV:  process.env.GATSBY_ENV,
    WHITELABEL_API_URL: process.env.GATSBY_WHITELABEL_API_URL
}

export default CONFIG;